import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import Popover from "@mui/material/Popover";
import clsx from "clsx";
import { FC } from "react";
import { generateStyles, getImageURL } from "../helpers/utils";
import {
  EDefaultConfigValues,
  IMenuButton,
  IUserProfile,
  TrustedWidgetConfig,
} from "../types";
import styles from "./AccountPopover.module.css";
import { CustomButton } from "./CustomButton";

interface IAccountPopoverProps {
  isOpen: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  profile: Partial<IUserProfile> | null;
  accountsMenu: IMenuButton[];
  config: TrustedWidgetConfig;
}

export const AccountPopover: FC<IAccountPopoverProps> = ({
  isOpen,
  anchorEl,
  onClose,
  profile,
  accountsMenu,
  config,
}) => {
  const customStyles = generateStyles(config);

  return (
    <Popover
      id="accounts-popover"
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: customStyles.borderRadius,
            backgroundColor: customStyles.background,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            padding: "16px",
            width: "100%",
            maxWidth: "280px",
          },
        },
      }}
    >
      <button onClick={onClose} className={styles.closeButton}>
        <CloseIcon
          style={{
            color: customStyles.text,
          }}
        />
      </button>
      <div className={styles.account}>
        <div>
          {profile?.picture ? (
            <img
              src={getImageURL(
                profile.picture,
                config?.issuer || EDefaultConfigValues.issuer
              )}
              className={styles.accountImage}
              style={{ borderColor: customStyles.text }}
            />
          ) : (
            <PersonIcon
              style={{
                width: "60px",
                height: "60px",
                color: customStyles.text,
              }}
              className={clsx(styles.accountImage, styles.accountImageDefault)}
            />
          )}
        </div>
        <p className={styles.text} style={{ color: customStyles.text }}>
          {profile?.given_name
            ? `${profile?.given_name} ${profile?.family_name}`
            : profile?.nickname}
        </p>
        {profile?.email && (
          <p className={styles.text} style={{ color: customStyles.text }}>
            {profile?.email}
          </p>
        )}
      </div>
      <div className={styles.divider}></div>
      <div className={styles.menu}>
        {config.menuButtons?.map((item) => (
          <CustomButton
            key={item.text}
            config={config}
            customStyles={item.customStyles || customStyles.accountButton}
            content={item}
            icon={item.icon}
          />
        ))}
      </div>
      {!!config?.menuButtons?.length && <div className={styles.divider}></div>}
      <div className={styles.menu}>
        {accountsMenu
          ?.filter((item) => item.type !== "lk_personal")
          .map((item) => (
            <CustomButton
              key={item.text}
              config={config}
              content={item}
              customStyles={customStyles.accountButton}
            />
          ))}
      </div>
      <div className={styles.buttons}>
        <CustomButton
          config={config}
          content={{
            text: "Профиль",
            type: "lk_personal",
            link:
              accountsMenu.find((item) => item.type === "lk_personal")?.link ||
              "",
          }}
          customStyles={customStyles.primaryButton}
        />

        <CustomButton
          config={config}
          content={{
            text: "Выход",
            type: "logout",
            link: "",
          }}
          customStyles={customStyles.secondaryButton}
        />
      </div>
    </Popover>
  );
};
